import React from 'react';

/**
 * Themed confirmation modal — Yes / No actions.
 */
export default function ConfirmDialog({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto px-4 py-6"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
      >
        <div className="relative w-full max-w-md animate-[bsi-modal-pop_220ms_ease-out] overflow-hidden rounded-[1.75rem] border border-sky-100 bg-gradient-to-br from-white via-white to-sky-50 p-6 text-center shadow-2xl shadow-slate-950/20 ring-1 ring-white/80">
          <div className="pointer-events-none absolute -right-10 -top-12 h-28 w-28 rounded-full bg-sky-200/50 blur-3xl" />
          <div className="relative mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-white shadow-lg shadow-sky-500/25">
            <span className="text-xl font-extrabold">?</span>
          </div>
          <h2
            id="confirm-dialog-title"
            className="relative text-xl font-extrabold tracking-tight text-slate-950"
          >
            {title}
          </h2>
          {message ? (
            <p className="relative mt-2 text-sm font-medium leading-6 text-slate-600">{message}</p>
          ) : null}
          <div className="relative mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={onCancel}
              className="w-full rounded-2xl border border-slate-200 bg-white px-6 py-2.5 text-sm font-bold text-slate-600 shadow-sm transition hover:-translate-y-0.5 hover:bg-slate-50 hover:shadow-md focus:outline-none focus:ring-4 focus:ring-sky-100 sm:w-auto"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="w-full rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100 sm:w-auto"
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
      <div
        className="fixed inset-0 z-[90] bg-slate-950/45 backdrop-blur-sm"
        aria-hidden="true"
        onClick={onCancel}
      />
    </>
  );
}
